// /** @module maps/google */
import {GoogleMap} from "./map_google";
import {getUrl} from "../main_ptx";
import {MAP_TYPE_EDIT_GZ, MAP_TYPE_EDIT_POI} from "./map_base";

/**
 * @alias Ptx.maps.GoogleEdit
 */
export const GoogleMapEdit = GoogleMap.extend(
		/** @lends module:maps/google */
		{
			editClusterOpts: {
				'general': {gridSize: 50, maxZoom: 15},
				'vehicle': {gridSize: 50, maxZoom: 12},
				'tp': {
					gridSize: 50, maxZoom: 14
					, styles: [{
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#ff00ff',
						textSize: 0.1
					}, {
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#ff0000',
						textSize: 0.1
					}, {
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#0000ff',
						textSize: 0.1
					}]
				}
			},
			drawingMng: null, //drawing manager of google
			allOverlays: null, //all items drawn on map
			buffer: null,//buffered shape of gz
			editTool: null,

			constructor: function (mapContainer, opts, mapSettings) {
				this.name = "GM_E";
				this.clusterOpts[MAP_TYPE_EDIT_GZ] = this.editClusterOpts;
				this.clusterOpts[MAP_TYPE_EDIT_POI] = this.editClusterOpts;
				this.allOverlays = [];
				opts['libraries'] = 'drawing,geometry';
				this.base(mapContainer, opts, mapSettings);
			},

			/** Init map drawing */
			internalMapInit: function (self) {
			},

			/** @see maps/base#findMapCreatorFunction_ */
			findMapCreatorFunction_: function () {
				var mt = this.opts.mapType;
				if (mt === MAP_TYPE_EDIT_GZ || mt === MAP_TYPE_EDIT_POI) {
					this.prepareEditGeozonePOIMap(mt === MAP_TYPE_EDIT_POI);
				} else {
					return this.base();
				}

			},
			/** @see maps/google#gjDataShow
			 *  Redefine behaviour, so we load geojson data as editable, when on editable map
			 * */
			gjDataShow: function (geoJsonData, afterLoadCallback) {
				var mt = this.opts.mapType;
				if (mt === MAP_TYPE_EDIT_GZ || mt === MAP_TYPE_EDIT_POI) {
					this.removeEditShapes();
					var feature = this.getFeature_(geoJsonData);
					this.geoJson = feature;

					var type = feature.properties.gzType;
					var radius = feature.properties.radius;
					//geometries, include points and multipolygon
					var gCollection = feature.geometry.geometries;
					var overlay;
					var gmapType;
					if (type == "POLYGON") {
						overlay = this.editCreators.createPolygonFromPoints(this, gCollection);
						gmapType = google.maps.drawing.OverlayType.POLYGON;
					} else if (type == "POINT") {
						overlay = this.editCreators.createCircle(this, gCollection, radius);
						gmapType = google.maps.drawing.OverlayType.CIRCLE;
					} else if (type == "POLYLINE") {
						overlay = this.editCreators.createPolyline(this, gCollection);
						gmapType = google.maps.drawing.OverlayType.POLYLINE;
					}

					this.addMapOverlay(overlay, {type: gmapType});
					this.gjDataShowBounds();

					if (typeof afterLoadCallback == 'function') {
						afterLoadCallback();
					}
				} else {
					return this.base();
				}


			},
			/**
			 * Helper to create feature from geojson, even plain geometry
			 * @param gj geojson
			 * @return GeoJSON Feature for map
			 */
			getFeature_: function (gj) {
				function getType(t) {
					if (t == "LineString") return "POLYLINE";
					return t.toUpperCase();
				}

				if (gj.type && gj.type == 'Feature') return gj;
				var geomType = getType(gj.type);

				var f = {
					type: 'Feature',
					properties: {
						gzType: geomType,
						radius: 0
					},
					geometry: {
						type: 'GeometryCollection',
						geometries: []
					}
				};
				var cs = gj.coordinates;
				var gs = f.geometry.geometries;
				for (var i = 0; i < cs.length; i++) {

					gs.push({type: 'Point', coordinates: cs[i]});
				}
				f.geometry.geometries.push(gj);
				return f;
			},

			/**
			 * Remove all edit shapes
			 */
			removeEditShapes: function () {
				// Remove existing overlays from the map
				for (var i = 0; i < this.allOverlays.length; i++) {
					if (this.allOverlays[i]) {
						this.allOverlays[i].setMap(null);
					}
				}
				this.allOverlays = [];
				//remove buffered item
				this.removeRealShape();
			},
			/**
			 * Check if something is drawn on the map
			 */
			hasSomeOverlays: function () {
				return (this.allOverlays.length > 0);
			},
			editCreators: {
				/**
				 * Create polygon from geometry collection
				 * @param gCollection - array of geomtries, uses Points only
				 */
				createPolygonFromPoints: function (self, gCollection) {
					var polygon = [];
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var ll = new google.maps.LatLng(coords[1], coords[0]);
							polygon.push(ll);
							self.geoBounds.extend(ll);
						}
					}
					return new google.maps.Polygon({
						paths: polygon,
						editable: true,
						draggable: true
					});
				},

				/**
				 * Create polygon from Polygon geojson
				 */
				createPolygon: function (self, coords, opts) {
					var polygon = [];
					for (var i in coords) {
						var ll = new google.maps.LatLng(coords[i][1], coords[i][0]);
						polygon.push(ll);
						//self.geoBounds.extend(ll);
					}
					var p = new google.maps.Polygon({
						paths: polygon,
						editable: false
					});

					if (typeof opts != 'undefined') {
						p.setOptions(opts);
					}
					return p;
				},

				/**
				 * TODO complete, update this.buffer to be able to contain more polygons
				 */
				createMultiPolygon: function (self, coords, opts) {
					for (var i in coords) {
						self.editCreators.createPolygon(self, coords[i][0], opts);
					}
				},

				/**
				 * Create circle from first point in gCollection and radius
				 */
				createCircle: function (self, gCollection, radius) {
					var center = null;
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var center = new google.maps.LatLng(coords[1], coords[0]);
							break;
						}
					}
					if (center != null) {
						var c = new google.maps.Circle({
							center: center,
							radius: radius,
							editable: true
						});
						self.geoBounds = c.getBounds();
						return c;
					}
					console.log('Unable to create circle')
				},

				createPolyline: function (self, gCollection) {
					var polygon = [];
					for (var i in gCollection) { //go through geometrycollection and create polygon from points
						var geom = gCollection[i];
						if (geom.type == "Point") {
							var coords = geom.coordinates;
							var ll = new google.maps.LatLng(coords[1], coords[0]);
							polygon.push(ll);
							self.geoBounds.extend(ll);
						}
					}
					return new google.maps.Polyline({
						path: polygon,
						editable: true
					});
				}
			},
			/**
			 * Add google map overlay
			 * @param overlay - google map overlay (POLYGON, CIRCLE, POLYLNE)
			 * @param evet - google map event, or at least object with "type" property to determine what overlay we have
			 */
			addMapOverlay: function (overlay, event) {
				if (overlay) {
					var self = this;
					var isDragging = false;

					function addShape(self) {
						self.removeEditShapes();
						self.allOverlays.push(overlay);
						overlay.setMap(self.map);

						function ev() {
							if (!isDragging) self.shapeChanged();
						}

						if (event && event.type == google.maps.drawing.OverlayType.CIRCLE) {
							var c = overlay.getCenter();
							self.propagateInfo({radius: overlay.getRadius(), lat: c.lat(), lon: c.lng(), fromMap: true});

							['radius_changed', 'center_changed'].forEach(eventName => {
								google.maps.event.addListener(overlay, eventName, function () {
									var c = overlay.getCenter();
									self.propagateInfo({radius: overlay.getRadius(), lat: c.lat(), lon: c.lng(), fromMap: true});
									ev();
								});
							});
						} else {
							var p = overlay.getPath();
							if (typeof p == 'undefined') p = overlay.getPaths();

							['insert_at', 'remove_at', 'set_at'].forEach(eventName => {
								google.maps.event.addListener(p, eventName, ev);
							});
						}

						// Disable events while dragging, so we don't spam the server with calculation requests
						google.maps.event.addListener(overlay, 'drag', function () {
							isDragging = true;
						});

						google.maps.event.addListener(overlay, 'dragend', function () {
							isDragging = false;
							ev();
						});

						ev();
						self.setMapMode('edit'); // After add, switch map to edit mode
					}

					// Always remove shapes before adding the new one
					addShape(self);
				}
			},
			/**
			 * Push info into HTML page
			 */
			propagateInfo: function (obj) {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				$(this.opts.radiusInput).val(Math.round(Number(obj.radius)));

				if (obj.fromMap == true) {
					if (obj.lat && obj.lon) {
						var lat = r_num(Number(obj.lat), 6);
						var lon = r_num(Number(obj.lon), 6);

						$(this.opts.latInput).val(lat);
						$(this.opts.lonInput).val(lon);
					}
				}

			},

			/**
			 * Refresh map and buffer drawn items
			 */
			shapeChanged: function () {
				var gjOut = $(this.opts.geoJsonOutput);
				if (gjOut !== null && gjOut !== '') {
					var rad = $(this.opts.radiusInput);
					var radius = rad.val();
					var gj = this.dumpGeoJSON();
					if (!this.isGeoJSONValid(gj)) return;

					gjOut.val(JSON.stringify(gj, null, ''));

					if (radius != '') {
						if (radius != '0') {
							this.drawRealShape(gj, radius);
						} else {
							this.removeRealShape();
						}
					} else {
						rad.val('0');
						this.removeRealShape();
					}
				}
			},

			/**
			 * Hide real geozone shape, buffered from server
			 */
			removeRealShape: function () {
				if (this.buffer) { // remove previous shape
					this.buffer.setMap(null);
					this.buffer = null;
				}
			},

			/**
			 * Draw buffered shape of given items
			 * @param geojson - data
			 * @param radius - meters to expand
			 */
			drawRealShape: function (geoJSON, radius) {
				if (geoJSON.type != 'Point') { // no need to buffer circle
					var gjStr = JSON.stringify(geoJSON, null, '');
					var self = this;
					this.removeRealShape();
					Ptx.fn.openPtx('/settings/geozones/geozones/buffer.json', "POST", {
						polyJson: gjStr,
						radius: radius
					}, function (data, svr) {
						var gj = JSON.parse(data);

						if (self.buffer) {
							self.buffer.setMap(null);
							self.buffer = null;
						}

						var ovl = self.editCreators.createPolygon(self, gj.coordinates[0][0],
								{strokeColor: 'red', fillOpacity: 0.15, fillColor: 'red', zIndex: -1}); // color options for buffered zone
						ovl.setMap(self.map);
						self.buffer = ovl;
					});
				}
			},

			/**
			 * Return GeoJSON object representation of items drawn on map
			 * @return geoJson object, not string!! use JSON.stringify(geoJSON, null, '') to get string
			 */
			dumpGeoJSON: function (data) {
				var overlays = this.allOverlays;
				if (typeof data != 'undefined') {
					overlays = data;
				}
				//convert to geoJSON as LineString or Polygon
				if (this.editTool == google.maps.drawing.OverlayType.POLYLINE) {
					return this.convertLineStringToGeoJSON(overlays);
				} else if (this.editTool == google.maps.drawing.OverlayType.POLYGON) {
					return this.convertPolygonToGeoJSON(overlays);
				} else {
					return this.convertPointToGeoJSON(overlays);
				}
			},
			convertPointToGeoJSON: function (overlays) {
				var coordinates = [];
				for (var i = 0; i < overlays.length; i++) {
					var c = overlays[i].getCenter();
					coordinates.push([c.lng(), c.lat()]);
				}
				return {'type': 'Point', 'coordinates': coordinates};
			},
			convertPolygonToGeoJSON: function (overlays) {
				var coordinates = [];
				for (var i = 0; i < overlays.length; i++) {
					var line = overlays[i].getPath().getArray();

					for (var j = 0; j < line.length; j++) {
						coordinates.push([line[j].lng(), line[j].lat()]);
					}

				}
				//add first point as last one
				coordinates.push([line[0].lng(), line[0].lat()]);
				return {'type': 'Polygon', 'coordinates': coordinates};
			},

			convertLineStringToGeoJSON: function (overlays) {
				var coordinates = [];
				for (var i = 0; i < overlays.length; i++) {
					var line = overlays[i].getPath().getArray();

					for (var j = 0; j < line.length; j++) {
						coordinates.push([line[j].lng(), line[j].lat()]);
					}
				}
				return {'type': 'LineString', 'coordinates': coordinates};
			},

			/**
			 * Init for edit shapes
			 */
			prepareEditGeozonePOIMap: function (editPOI) {
				var modes = [
					google.maps.drawing.OverlayType.POLYGON,
					google.maps.drawing.OverlayType.CIRCLE,
					google.maps.drawing.OverlayType.POLYLINE
				];
				if (editPOI) {
					modes = [google.maps.drawing.OverlayType.CIRCLE]
				}
				//console.log("Create editable map");
				var drawingManager = new google.maps.drawing.DrawingManager({
					drawingMode: null,
					drawingControl: false,
					drawingControlOptions: {
						position: google.maps.ControlPosition.BOTTOM_CENTER,
						drawingModes: modes
					},
					polygonOptions: {
						editable: true,
						zIndex: 1,
						draggable: true
					},
					polylineOptions: {
						editable: true,
						zIndex: 1,
						draggable: true
					},
					circleOptions: {
						editable: true,
						zIndex: 1,
						draggable: true
					}
				});

				drawingManager.setMap(this.map);
				this.drawingMng = drawingManager;
				var self = this;
				google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
					self.addMapOverlay(event.overlay, event);
				});
			},


			/**
			 * Change edit tool of map
			 * @param type - string POINT, POLYGON, POLYLINE
			 */
			setEditTool: function (type) {
				var mode = null;
				if (type == "POINT") {
					mode = google.maps.drawing.OverlayType.CIRCLE
				} else if (type == 'POLYLINE') {
					mode = google.maps.drawing.OverlayType.POLYLINE
				} else if (type == 'POLYGON') {
					mode = google.maps.drawing.OverlayType.POLYGON
				}
				this.editTool = mode;
				if (mode != null) {
					this.drawingMng.setOptions({drawingMode: mode});
				}
			},
			/**
			 * Change map between edit and draw mode of shapes
			 * @param mode - draw or edit
			 */
			setMapMode: function (mode) {
				if (mode == 'edit') {
					this.drawingMng.setOptions({drawingMode: null});
				} else {
					this.drawingMng.setOptions({drawingMode: this.editTool});
				}
			},

			/**
			 * Set POI on map
			 * @param lat
			 * @param lon
			 * @param radius in meters
			 * @param callback after item is visible
			 * @return true if item was shown
			 */
			showPOI: function (lat, lon, radius, callback) {
				this.removeEditShapes();
				var itemWasDrawn = true;
				if (lat && lat != '' && lon && lon != '' && radius && radius != '' && (Number(radius) > 0)) {
					var mm = this.map;
					var circleOptions = {
						center: {lat: Number(lat), lng: Number(lon)},
						radius: Number(radius),
						map: mm,
						editable: true,
						draggable: true,
						clickable: true
					};

					var circle = new google.maps.Circle(circleOptions);
					this.addMapOverlay(circle, {type: google.maps.drawing.OverlayType.CIRCLE});
				} else {
					itemWasDrawn = false;
					this.setEditTool('POINT');
					this.setMapMode('draw');
				}
				if (callback) callback();
				return itemWasDrawn;
			},

			/**
			 * Update point from controls given as opt when constructed, and zoom to it
			 * works only on circle gz, or POI, does nothing for any other type
			 */
			updatePoint: function () {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				var circle = null;
				if (this.allOverlays.length > 0) {
					if (typeof this.allOverlays[0].center != 'undefined') {
						circle = this.allOverlays[0];
					}
				}
				if (circle != null) {
					var sRad = $(this.opts.radiusInput).val();
					if (sRad != '') {
						circle.setRadius(Number(sRad));
					}
					var sLat = $(this.opts.latInput).val();
					var sLon = $(this.opts.lonInput).val();
					if (sLat != '' && sLon != '') {
						circle.setCenter({lat: r_num(Number(sLat), 6), lng: r_num(Number(sLon), 6)});
					}

					this.map.fitBounds(circle.getBounds());
				}
			}
		});
